import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin, Table, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import trans from './translation';
import Message from '../../component/message/message';

const { Option } = Select;
const CohortProgModal = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [cohortList, setCohortList] = useState([]);
    const [deptList, setDeptList] = useState([]);
    const tableColumns = {
        cohortProgId: "cohort_prog_id",
        cohortYear: "cohort_year",
    }


    useEffect(() => {
        // search(pageSize, 1, "N");
        searchAllDept();
        searchCohortList()
    }, []);

    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("programmeParameters/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
                let newModel = { cohortYear: Config.cohort?.cohortYear };
                setSearchModel(newModel);
                // form2.setFieldsValue(newModel)
                search(pageSize, 1, "N", false, newModel)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        Base.callBackApi("studentProgramme/searchCohortProgramme", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        form.resetFields()
        let newModel = { cohortYear: Config.cohort?.cohortYear };
        setSearchModel(newModel);
        // search(pageSize, 1, "reset")
    }

    const save = () => {
        if (!checkboxState[0] || checkboxState[0] === null) {
            errFrameShow("error", 'Please select a reord.');
        } else {
            props.onClose(true, checkboxState[0]);
        }
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }
    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const rowSelection = {
        type: 'radio',
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };


    const columns = [
        // {
        //     title: 'Cohort Programme ID',
        //     dataIndex: 'cohortProgId',
        //     className: 'tableWidth20',
        //     sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortProgId') },
        // },
        // {
        //     title: trans.cohortYear[Config.backLang],
        //     dataIndex: 'cohortYear',
        //     className: 'tableWidth25',
        //     sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        // },
        {
            title: "Department",
            dataIndex: 'deptCode',
            className: 'tableWidth25',
            render: (text, record) => text + '-' + record.deptDisplayName,
        },
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth25',
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth40',
        },
        {
            title: "Cohort",
            dataIndex: 'cohortYear',
            className: 'tableWidth10',
        },

    ];
    return (
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                visible={true}//控制弹框是否显示
                title="Programme Name by Cohort"//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'1270px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>Select</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                {/* 提示信息弹框 */}
                <Message ref={messageRef} />
                <div className='sysSearchRow sysSearchBox programmeSetupProgModal'>
                    <Form form={form} >
                        <div className='sysRow'>
                            <div className='sysCol'>
                                <div className="sysParam">{trans.cohortYear[Config.backLang]}</div>
                                <div className="sysSerchInput">
                                    <Select className="sysSelect"
                                        value={searchModel.cohortYear || ''}
                                        onChange={(value) => searchChange('cohortYear', value)}
                                    >
                                        <Option value=''></Option>
                                        {cohortList.map((item) => <Option key={item.cohortYear} value={item.cohortYear}>{item.cohortYear}</Option>)}
                                    </Select>
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">Department</div>
                                <div className="sysSerchInput">
                                    <Select className="sysSelect" placeholder="Department"
                                        value={searchModel.deptId || ''}
                                        onChange={(e) => searchChange('deptId', e)}
                                    >
                                        <Option value=""></Option>
                                        {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                    </Select>
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysParam">Programme Code</div>
                                <div className="sysSerchInput">
                                    <Input type="text" placeholder="Programme Code" value={searchModel.progCode || ''}
                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        onChange={(e) => searchChange('progCode', e.target.value)} />
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysParam">Programme Name</div>
                                <div className="sysSerchInput">
                                    <Input type="text" placeholder="Programme Name" value={searchModel.progTitle || ''}
                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        onChange={(e) => searchChange('progTitle', e.target.value)} />
                                </div>
                            </div>
                            <div className='sysSearchButton'>
                                <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className="sysLineEight"></div>

                <div className="sysTable" id="tableOne">
                    <Table
                        rowSelection={rowSelection} //选择
                        scroll={{ x: 1000 }}
                        rowKey="cohortProgId" //Key值
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                            onChange: onChange,                        //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                            total: tablesCount,             //总共多少条数据
                            current: current,                //当前页
                            pageSize: pageSize,              //每页显示多少条数据
                            defaultCurrent: 1,                               //默认当前页为1
                            size: "small"
                        }}
                        onChange={handleTableChange}
                        onRow={(record) => {
                            return {
                                onClick: event => Base.selectRadioRowNew.call(this, record, 'cohortProgId', selectedRowKeys, setCheckboxState, setSelectedRowKeys),
                            };
                        }}
                    />
                </div>

            </Modal>
        </Spin >
    )

}

CohortProgModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default CohortProgModal;